import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnterKeyboardHints = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 18,
	viewBox: "0 0 24 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V14C23.5 15.933 21.933 17.5 20 17.5H4C2.067 17.5 0.5 15.933 0.5 14V4C0.5 2.067 2.067 0.5 4 0.5Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V14C23.5 15.933 21.933 17.5 20 17.5H4C2.067 17.5 0.5 15.933 0.5 14V4C0.5 2.067 2.067 0.5 4 0.5Z",
			stroke: "#D9D9D9",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.3234 3.55567L16.416 3.55566C16.3494 3.55566 16.295 3.6077 16.295 3.67129L16.295 11.1579L8.94469 11.1579L8.94469 10.1028C8.94469 10.006 8.82672 9.95108 8.74807 10.0118L6.60196 11.6305C6.5875 11.6413 6.57581 11.6551 6.56776 11.6709C6.55972 11.6867 6.55554 11.704 6.55554 11.7216C6.55554 11.7391 6.55972 11.7564 6.56776 11.7722C6.57581 11.788 6.5875 11.8018 6.60196 11.8126L8.74807 13.4313C8.82823 13.492 8.94469 13.4371 8.94469 13.3403L8.94469 12.2563L16.4765 12.2563C17.0104 12.2563 17.4444 11.8415 17.4444 11.3313L17.4444 3.67129C17.4444 3.6077 17.39 3.55567 17.3234 3.55567Z",
			fill: "#434343"
		})
	]
});
const ForwardRef = forwardRef(SvgEnterKeyboardHints);
export { ForwardRef as ReactComponent };
